import * as React from 'react'

import { List } from './List'
import { IReplacementPrice } from './models'

interface IProps {
    device:                          string
    model:                           string
    capacity:                        string
    replacementPrices:               IReplacementPrice[]
    handleReplacementAcceptBtnClick: () => void
}

export function ReplacementQuote({ device, model, capacity, replacementPrices, handleReplacementAcceptBtnClick }: IProps) {
    return (
        <div className="cc-quote__item">
            <div className="row">
                <div className="col-xs-12 text-center">
                    <span className="cc-quote__title">
                        To replace your {device} {model} {capacity}GB is:
                    </span>
                    {
                        replacementPrices.length === 1 &&
                        <span className="cc-quote__amount">R{replacementPrices[0].replacementPrice.toFixed(2)}</span>
                    }
                    {
                        replacementPrices.length > 1 &&
                        <div className="cc-quote__replacement-price-container">
                            {
                                replacementPrices.map(({ capacity, replacementPrice }, i) =>
                                    <div key={i} className="cc-quote__replacement-price-item">
                                        for <b>{capacity}GB</b> model: <b>R{replacementPrice.toFixed(2)}</b>
                                    </div>
                                )
                            }
                        </div>
                    }
                    This includes:
                    <List
                        className="cc-quote__list"
                        listStyle="check"
                        items={[
                            '12-month warranty, our pre owned phones are quality approved and verified',
                            'Your money back in full if you’re not happy with the phone',
                            '10% discount on any future repairs'
                        ]}
                    />
                </div>
            </div>
            <div className="cc-quote__buttons-wrapper text-center">
                <div>
                    <button
                        className="cc-quote__accept-btn btn btn-success btn-lg btn-cc-green"
                        onClick={handleReplacementAcceptBtnClick}
                    >
                        Yes, Replace it
                    </button>
                </div>
            </div>
        </div>
    )
}
